import { LANGUAGE_TYPE } from 'common/enums'
import translationsFallbackEN from 'common/translationsFallbackEN.json'
import translationsFallbackHY from 'common/translationsFallbackHY.json'
import envConfig from 'config'
import { fetchCurrentLanguage } from 'features/Auth/actions'
import { ACTION_TYPES } from 'features/Translations/actions'
import type { ActionTypes, TranslationsType } from 'features/Translations/types'

const parser = (dataToParse: TranslationsType) => {
  return ({
    inviteViaLink: {
      inviteViaLink: dataToParse?.contacts_invite_sheet_link,
      copyLink: dataToParse?.contact_invite_link_copy,
      copyLinkShort: dataToParse?.contact_invite_link_copy_short,
      copyToClipBoard: dataToParse?.contacts_invite_link_copied,
      copyToClipBoardShort: dataToParse?.contacts_invite_link_copied_short,
      profileShareLinkCopiedTitle: dataToParse?.profile_share_link_copied_title,
      welcomeContactsShareLinkSubject: dataToParse?.welcome_contacts_share_link_subject,
      welcomeContactsShareLinkBody: dataToParse?.welcome_contacts_share_link_body,
      profileShareLinkSubject: dataToParse?.other_profile_share_link_subject,
      profileShareLinkBody: dataToParse?.other_profile_share_link_body,
      myProfileShareLinkSubject: dataToParse?.my_profile_share_link_subject,
      myProfileShareLinkBody: dataToParse?.my_profile_share_link_body
    },
    notifications: {
      photoMessage: dataToParse?.notification_photo_message,
      voiceMessage: dataToParse?.notification_voice_message,
      jobNotificationMessage: dataToParse?.local_job_notification_alert_body
    },
    myNetwork: {
      title: dataToParse?.contacts_text_title,
      subtitle: dataToParse?.contacts_text_subtitle,
      search: dataToParse?.contacts_search_placeholder,
      sort: dataToParse?.contacts_profile_button_sort,
      sortingFirstTrusted: dataToParse?.contacts_text_sorting_first_trusted,
      sortingFirstUnTrusted: dataToParse?.contacts_text_sorting_first_untrusted,
      trustedBy: dataToParse?.profile_table_section_trusted_by,
      trustingTitle: dataToParse?.profile_trusting,
      myProfileContacts: dataToParse?.my_profile_contacts,
      trustedTitle: dataToParse?.network_modal_trusted_title,
      otherProfiletrustedTitle: dataToParse?.other_profile_trusting_title,
      searchTrustedUserPlaceholder: dataToParse?.trusted_user_search_placeholder,
      searchOtherTrustedUserPlaceholder: dataToParse?.other_trusted_user_search_placeholder,
      shareProfile: dataToParse?.contacts_profile_button_share_link,
      others: dataToParse?.contacts_title_others_section,
      firstLevel: dataToParse?.contacts_title_first_section,
      secondLevel: dataToParse?.contacts_title_second_section,
      groupsLevel: dataToParse?.contacts_title_groups_section,
      globalSearchLevel: dataToParse?.contacts_title_global_section,
      globalSearchLevelEmpty: dataToParse?.contacts_title_global_section_empty,
      firstEmptyStateTitle: dataToParse?.contacts_text_empty_first_section,
      secondEmptyStateTitle: dataToParse?.contacts_text_empty_second_section,
      groupsEmptyStateTitle: dataToParse?.contacts_text_empty_groups_section,
      contactsEmptyStateTitle: dataToParse?.contacts_text_empty_contacts_section,
      globalSearchEmptyStateTitle: dataToParse?.contacts_text_empty_global_search_section,
      selectContactText: dataToParse?.network_text_select_contact,
      contactsEmptyTitle: dataToParse?.contacts_empty_title,
      contactsEmptyDescription: dataToParse?.contacts_empty_description,
      networkInviteButtonTitle: dataToParse?.network_invite_button_title,
      networkShareModalTitle: dataToParse?.network_share_modal_title,
      emptyNetworkShareModalTitle: dataToParse?.empty_network_share_modal_title,
      networkShareModalHeader: dataToParse?.network_share_modal_header,
      networkFiltersFirst: dataToParse?.network_filters_first,
      networkFiltersSecond: dataToParse?.network_filters_second,
      networkFiltersGroups: dataToParse?.network_filters_groups,
      networkFiltersAll: dataToParse?.network_filters_all,
      networkFiltersAllContacts: dataToParse?.network_filters_all_contacts,
      networkFiltersGlobal: dataToParse?.network_filters_global,
      networkModalFiltersTrusted: dataToParse?.network_modal_filters_trusted,
      networkModalFiltersTrusting: dataToParse?.network_modal_filters_trusting,
      networkModalAddButton: dataToParse?.trust_modal_add_button,
      myNetworkAddContactButton: dataToParse?.my_network_add_contact_button,
      profileTrustedBySummaryText: dataToParse?.profile_trusted_by_summary_text,
      contactsGlobalShowMore: dataToParse?.contacts_global_show_more,
      emptyGroupTitle: dataToParse?.empty_group_title,
      emptyGroupDescription: dataToParse?.empty_group_description,
      groupInviteButtonTitle: dataToParse?.group_invite_button_title,
      groupShareModalTitle: dataToParse?.group_share_modal_title,
      groupCopyButtonTitle: dataToParse?.group_copy_button_title,
      groupCopiedButtonTitle: dataToParse?.group_copied_button_title,
      emptyGroupAddUserOptionButtonTitle: dataToParse?.empty_group_add_user_option_button_title,
      emptyGroupShareLinkOptionButtonTitle: dataToParse?.empty_group_share_link_option_button_title,
      emptyGroupCopyLinkOptionButtonTitle: dataToParse?.empty_group_copy_link_option_button_title,
      emptyGroupCopyLinkOptionButtonCopiedTitle: dataToParse?.empty_group_copy_link_option_button_copied_title,
      emptyGroupShareLinkOptionModalTitle: dataToParse?.empty_group_share_link_option_modal_title,
      emptyGroupInviteOptionsModalInfoText: dataToParse?.empty_group_invite_options_modal_info_text,
      emptyGroupInviteOptionsModalEditButton: dataToParse?.empty_group_invite_options_modal_edit_settings,
      groupAddUserOptionButtonTitle: dataToParse?.group_add_user_option_button_title,
      groupShareLinkOptionButtonTitle: dataToParse?.group_share_link_option_button_title,
      groupCopyLinkOptionButtonTitle: dataToParse?.group_copy_link_option_button_title,
      groupCopyLinkOptionButtonCopiedTitle: dataToParse?.group_copy_link_option_button_copied_title,
      groupShareLinkOptionModalTitle: dataToParse?.group_share_link_option_modal_title,
      groupInviteOptionsModalInfoText: dataToParse?.group_invite_options_modal_info_text,
      groupAddUsersModalTitle: dataToParse?.group_add_users_modal_title,
      groupAddUsersModalEmptySearchTitle: dataToParse?.group_add_users_modal_empty_search_title,
      groupAddUsersModalEmptySearchSubTitle: dataToParse?.group_add_users_modal_empty_search_subtitle,
      groupAddUsersModalSearchPlaceholder: dataToParse?.group_add_users_modal_search_placeholder,
      groupInviteOptionsModalEditButton: dataToParse?.group_invite_options_modal_edit_settings,
      groupAddUsersModalButtonAdded: dataToParse?.group_add_users_modal_button_added,
      groupAddUsersModalButtonAdd: dataToParse?.group_add_users_modal_button_add,
      groupAddUsersModalButtonRemove: dataToParse?.group_add_users_modal_button_remove,
      groupDropdownButtonNewGroup: dataToParse?.group_dropdown_button_new_group,
      networkShareGroupModalTitle: dataToParse?.network_share_group_modal_title,
      networkDropDownTitle: dataToParse?.network_dropdown_title,
      emptyNetworkDropDownTitle: dataToParse?.empty_network_dropdown_title,
      createGroupModalTitle: dataToParse?.create_group_modal_title,
      editGroupModalTitle: dataToParse?.edit_group_modal_title,
      createGroupModalSetPhoto: dataToParse?.create_group_modal_set_photo,
      createGroupModalInputTitle: dataToParse?.create_group_modal_input_title,
      createGroupModalErrorMessage: dataToParse?.create_group_modal_error_message,
      createGroupModalCancelButton: dataToParse?.create_group_modal_cancel_button,
      createGroupModalCreateButton: dataToParse?.create_group_modal_create_button,
      createGroupModalUpdateButton: dataToParse?.create_group_modal_update_button,
      groupDoesNotExistTitle: dataToParse?.group_does_not_exist_title,
      groupDoesNotExistDesc: dataToParse?.group_does_not_exist_desc,
      groupDoesNotExistButton: dataToParse?.group_does_not_exist_button,
      joinGroupMembersText: dataToParse?.join_group_members_text,
      joinGroupMemberText: dataToParse?.join_group_member_text,
      joinGroupBlockedMemberText: dataToParse?.join_group_blocked_member_text,
      joinPrivateGroupMembersText: dataToParse?.join_private_group_members_text,
      joinPrivateGroupMembersTextSent: dataToParse?.join_private_group_members_text_sent,
      joinGroupButton: dataToParse?.join_group_button,
      groupMemberOwnerText: dataToParse?.group_member_owner_text,
      groupMemberButtonApprove: dataToParse?.group_member_button_approve,
      groupMemberButtonDeny: dataToParse?.group_member_button_deny,
      groupActionShareSettings: dataToParse.group_action_share_settings,
      groupActionLeaveGroup: dataToParse.group_action_leave_group,
      groupActionDeleteGroup: dataToParse.group_action_delete_group,
      groupActionMoreButton: dataToParse.group_more_button,
      memberActionTrust: dataToParse.member_action_trust,
      memberActionUntrust: dataToParse.member_action_untrust,
      memberActionAddContact: dataToParse.member_action_add_contact,
      memberActionRemoveContact: dataToParse.member_action_remove_contact,
      memberActionRemoveFromGroup: dataToParse.member_action_remove_from_group,
      deleteGroupModalTitle: dataToParse.delete_group_modal_title,
      deleteGroupSecondaryButtonText: dataToParse.delete_group_secondary_button_text,
      deleteGroupPrimaryButtonText: dataToParse.delete_group_primary_button_text,
      deleteGroupModalDescription: dataToParse.delete_group_modal_description,
      leaveGroupModalTitle: dataToParse.leave_group_modal_title,
      leaveGroupSecondaryButtonText: dataToParse.leave_group_secondary_button_text,
      leaveGroupPrimaryButtonText: dataToParse.leave_group_primary_button_text,
      leaveGroupModalDescription: dataToParse.leave_group_modal_description,
      removeContactModalTitle: dataToParse.remove_contact_modal_title,
      removeContactSecondaryButtonText: dataToParse.remove_contact_secondary_button_text,
      removeContactPrimaryButtonText: dataToParse.remove_contact_primary_button_text,
      removeContactModalDescription: dataToParse.remove_contact_modal_description,
      removeFromGroupModalTitle: dataToParse.remove_from_group_modal_title,
      removeFromGroupSecondaryButtonText: dataToParse.remove_from_group_secondary_button_text,
      removeFromGroupPrimaryButtonText: dataToParse.remove_from_group_primary_button_text,
      removeFromGroupModalDescription: dataToParse.remove_from_group_modal_description,
      resetLinkModalTitle: dataToParse.reset_link_modal_title,
      resetLinkSecondaryButtonText: dataToParse.reset_link_secondary_button_text,
      resetLinkPrimaryButtonText: dataToParse.reset_link_primary_button_text,
      resetLinkModalDescription: dataToParse.reset_link_modal_description,
      untrustModalTitle: dataToParse.untrust_modal_title,
      untrustSecondaryButtonText: dataToParse.untrust_secondary_button_text,
      untrustPrimaryButtonText: dataToParse.untrust_primary_button_text,
      untrustModalDescription: dataToParse.untrust_modal_description,
      groupPageEmptySearchTitle: dataToParse.group_page_empty_search_title,
      groupPageEmptySearchSubtitle: dataToParse.group_page_empty_search_subtitle,
      groupPageSearchPlaceholder: dataToParse.group_page_search_placeholder,
      groupPageCancelSearchButtonText: dataToParse.group_page_cancel_search_button_text,
      groupPageInviteButtonTitle: dataToParse.group_main_view_invite_button,
      groupPageSearchButtonTitle: dataToParse.group_search_button,
      groupPageRequestsSectionTitle: dataToParse.group_page_requests_section_title,
      groupPageMembersSectionTitle: dataToParse.group_page_members_section_title,
      groupPageInviteModalTitle: dataToParse.group_page_invite_modal_title,
      groupSettingsModalTitle: dataToParse.group_settings_modal_title,
      groupSettingsModalSecondaryButtonText: dataToParse.group_settings_modal_secondary_button_text,
      groupSettingsModalPrimaryButtonText: dataToParse.group_settings_modal_primary_button_text,
      groupSettingsModalDescription: dataToParse.group_settings_modal_description,
      groupSettingsModalLinkSectionTitle: dataToParse.group_settings_modal_link_section_title,
      groupSettingsModalGroupAccessTitle: dataToParse.group_settings_modal_group_access_title,
      groupSettingsModalGroupLinkTitle: dataToParse.group_settings_modal_group_link_title,
      groupSettingsModalApprovalText: dataToParse.group_settings_modal_approval_text,
      groupSettingsModalCopiedText: dataToParse.group_settings_modal_link_copy,
      groupSettingsModalCopyText: dataToParse.group_settings_modal_copy_text,
      groupSettingsModalUnableChangePrivacy: dataToParse.group_settings_modal_unable_change_privacy,
      groupMemberRequestToJoinText: dataToParse.group_member_request_to_join_text,
      swapContactsModalTitle: dataToParse.swap_contacts_modal_title,
      searchInTrustedContactsPlaceholder: dataToParse.swap_contacts_search_placeholder,
      swapContactsModalButtonSwap: dataToParse.swap_contacts_modal_button_swap,
      swapModalTitle: dataToParse.swap_modal_title,
      swapModalDescription: dataToParse.swap_modal_description,
      swapModalPrimaryButtonText: dataToParse.swap_modal_primary_button_text,
      swapModalSecondaryButtonText: dataToParse.swap_modal_secondary_button_text,
      blockUserModalTitle: dataToParse.block_user_modal_title,
      blockUserModalDescription: dataToParse.block_user_modal_description,
      blockUserSecondaryButtonText: dataToParse.contacts_profile_button_cancel_block,
      blockUserPrimaryButtonText: dataToParse.contacts_profile_button_block,
      pendingButtonNotNow: dataToParse.group_button_not_now,
      pendingButtonOpen: dataToParse.group_button_open,
      pendingGroupText: dataToParse.network_group_accepted,
      groupAddUsersModalContactsSectionTitle: dataToParse.group_add_users_modal_contacts_section_title,
      groupAddUsersModalOthersSectionTitle: dataToParse.group_add_users_modal_others_section_title,
      groupAddUsersModalEmptyTitle: dataToParse.group_add_users_modal_empty_title,
      groupAddUsersModalEmptyDescription: dataToParse.group_add_users_modal_empty_description,
      groupPageInviteSubject: dataToParse.group_page_invite_by_gmail_subject,
      groupPageInviteBody: dataToParse.group_page_invite_body,
      groupPageBlockedDescription: dataToParse.group_page_blocked_modal_info_description,
      groupPageBlockedByDescription: dataToParse.group_page_blocked_by_modal_info_description
    },
    profile: {
      title: dataToParse?.profile_settings_sheet_account_text_title,
      links: dataToParse?.profile_edit_profile_fields_text_social_media,
      vacancies: dataToParse?.contacts_profile_segmented_control_vacancies_title,
      job: dataToParse?.profile_edit_profile_fields_text_job,
      industry: dataToParse?.profile_edit_profile_fields_text_industry,
      company: dataToParse?.profile_edit_profile_fields_text_company,
      aboutMe: dataToParse?.profile_table_section_name_about_me,
      edit: dataToParse?.profile_edit_profile_fields,
      linksLimit: dataToParse?.profile_edit_profile_fields_text_links_limit,
      url: dataToParse?.profile_edit_profile_fields_text_social_media_url,
      requiredLinkNameErrorMsg: dataToParse?.profile_edit_links_required_link_name,
      requiredLinkUrlErrorMsg: dataToParse?.profile_edit_links_required_link_url,
      correctLinkErrorMsg: dataToParse?.profile_edit_links_correct_link_error_message,
      duplicateLinksErrorMsg: dataToParse?.profile_edit_links_duplicate_error_message,
      linkName: dataToParse?.profile_edit_profile_fields_text_social_media_link_name,
      displayName: dataToParse?.profile_edit_profile_fields_text_display_name,
      jobTitle: dataToParse?.job_title,
      prepositionAt: dataToParse?.profile_view_text_at,
      tags: dataToParse?.profile_edit_profile_fields_text_tags,
      location: dataToParse?.company_info_location,
      companyAddressOrLocation: dataToParse?.profile_edit_profile_fields_text_company_address,
      editTagsSubtitle: dataToParse?.profile_edit_text_tags_subtitle,
      maxCountTrusts: envConfig.isProd
        ? dataToParse?.trust_max_limit_count_prod
        : dataToParse?.trust_max_limit_count_dev,
      max: dataToParse?.onboarding_text_max,
      tagsLimitErrorMsg: dataToParse?.profile_edit_text_tags_limit_error,
      description: dataToParse?.profile_edit_fields_description,
      workingPolicy: dataToParse?.contacts_profile_segmented_control_working_policy,
      salary: dataToParse?.contacts_profile_segmented_control_salary,
      aboutJob: dataToParse?.contacts_profile_segmented_control_about_job,
      loadButton: dataToParse?.profile_photo_load,
      removeButton: dataToParse?.profile_photo_remove,
      editButton: dataToParse?.profile_photo_edit,
      backButton: dataToParse?.profile_photo_back,
      saveButton: dataToParse?.profile_photo_save,
      notSpecifiedSalary: dataToParse?.choose_job_not_specified,
      incorrectField: dataToParse?.onboarding_incorrect_field,
      openTo: dataToParse?.edit_resume_title,
      hiring: dataToParse?.edit_vacancy_title,
      createOpenTo: dataToParse?.create_resume_title,
      createHiring: dataToParse?.create_vacancy_title,
      save: dataToParse?.button_save,
      cancel: dataToParse?.profile_settings_actions_delete_profile_alert_cancel,
      vacancy: dataToParse?.contacts_profile_segmented_control_vacancy,
      textClosedVacancy: dataToParse?.vacancy_closed_title,
      maxVacanciesCount: dataToParse?.max_vacancies_count,
      maxResumesCount: dataToParse?.max_resumes_count,
      jobHistory: dataToParse?.profile_job_history,
      emptyAboutTab: dataToParse?.about_other_profile_empty_state,
      companyInfo: dataToParse?.company_info_company,
      editProfileTitle: dataToParse?.profile_edit_profile_fields_text_title,
      tagsSubtitle: dataToParse?.tags_text_field_title,
      trustLimit: dataToParse?.trust_limit_modal_title,
      editTrusts: dataToParse?.trust_limit_modal_primary_button_text,
      trustLimitMessage: dataToParse?.trust_limit_modal_description,
      networkTrustLimitToastMessage: dataToParse?.network_trust_limit_toast_message,
      buttonTextOk: dataToParse?.trust_limit_modal_secondary_button_text,
      suggestedSectionTitle: dataToParse?.contacts_text_suggested_section,
      emptyTrustingHelperTitle: dataToParse?.contacts_text_empty_trusting_section_title,
      emptyTrustingHelperSubtitle: dataToParse?.contacts_text_empty_trusting_section_subtitle,
      profileTitle: dataToParse?.profile_text_title,
      helperTextLimit: dataToParse?.profile_edit_text_limit_error,
      addNew: dataToParse?.profile_edit_add_new_vacancy,
      helperJobTitle: dataToParse?.empty_job_title_error,
      helperCurrency: dataToParse?.vacancies_add_vacancy_error_message_currency,
      locationTitle: dataToParse?.profile_open_to_location,
      jobTypeTitle: dataToParse?.profile_publish_job_type_of_job,
      jobTypeErrorText: dataToParse?.profile_publish_work_type_error_text,
      jobLocationTitle: dataToParse?.profile_table_section_name_company_address,
      jobLocationTypeTitle: dataToParse?.profile_publish_job_location_type,
      jobAudienceTitle: dataToParse?.profile_open_to_job_audience,
      currency: dataToParse?.profile_add_vacancies_currency,
      salaryFrom: dataToParse?.profile_add_vacancies_from,
      salaryTo: dataToParse?.profile_add_vacancies_to,
      locationTypeError: dataToParse?.profile_publish_location_typ_error_text,
      locationError: dataToParse?.profile_publish_locations_error_text,
      rateError: dataToParse?.profile_publish_rate_error_text,
      salaryPartiallyFilledError: dataToParse?.profile_publish_partially_error_text,
      errorMessageSalaryTo: dataToParse?.vacancies_error_message_salary_to,
      errorMessageSalaryFrom: dataToParse?.vacancies_error_message_salary_from,
      buttonTextPublish: dataToParse?.profile_publish_job_button_title,
      buttonTextCancel: dataToParse?.profile_cancel_job_button_title,
      rate: dataToParse?.vacancies_add_vacancy_rate,
      textAnd: dataToParse?.phone_enter_text_legal_and,
      alertMsg: dataToParse?.vacancy_archive_alert_message,
      deleteVacancyMessage: dataToParse?.vacancy_delete_alert_message,
      deleteVacancyTitle: dataToParse?.vacancy_delete_alert_title,
      closeButton: dataToParse?.profile_button_close,
      deleteButton: dataToParse?.button_delete,
      subtitleVacancyDetails: dataToParse?.profile_open_to_details,
      wrongSalaryRange: dataToParse?.vacancies_error_message_wrong_salary_range,
      specialityAboutMe: dataToParse?.vacancy_description_open_to_about_me,
      vacancyAboutErrorMessage: dataToParse?.edit_vacancy_empty_description_error,
      specialtyAboutErrorMessage: dataToParse?.edit_resume_empty_description_error,
      closeHiring: dataToParse?.vacancy_archive_alert_title,
      vacanciesEmptyDescription: dataToParse?.vacancies_empty_description,
      deleteSpecialityTitle: dataToParse?.resume_delete_alert_title,
      deleteSpecialityMessage: dataToParse?.resume_delete_alert_message,
      createVacancyEmptyUrlTitle: dataToParse?.create_vacancy_empty_url_title,
      createResumeEmptyUrlTitle: dataToParse?.create_resume_empty_url_title,
      createResumeFilledUrlTitle: dataToParse?.create_resume_filled_url_title,
      createVacancyFilledUrlTitle: dataToParse?.create_vacancy_filled_url_title,
      createSpecialtyUrlMinCharCountErrorText: dataToParse?.create_resume_error_message_url_min_count,
      createVacancyUrlMinCharCountErrorText: dataToParse?.create_vacancy_error_message_url_min_count,
      specialtyUrlMinCharCountErrorText: dataToParse?.resume_error_message_url_min_count,
      vacancyUrlMinCharCountErrorText: dataToParse?.vacancy_error_message_url_min_count,
      vacancyDetailsAdditionalSettings: dataToParse?.vacancy_details_additional_settings,
      resumeDetailsAdditionalSettings: dataToParse?.resume_details_additional_settings,
      vacancyDetailsDescriptionTitle: dataToParse?.vacancy_details_description_title,
      createResumeDescriptionTitle: dataToParse?.create_resume_description_title,
      createVacancyDescriptionTitle: dataToParse?.create_vacancy_description_title,
      editResumeDescriptionTitle: dataToParse?.edit_resume_description_title,
      editVacancyDescriptionTitle: dataToParse?.edit_vacancy_description_title,
      createResumeDescriptionHelper: dataToParse?.create_resume_description_helper,
      createVacancyDescriptionHelper: dataToParse?.create_vacancy_description_helper,
      editResumeDescriptionHelper: dataToParse?.edit_resume_description_helper,
      editVacancyDescriptionHelper: dataToParse?.edit_vacancy_description_helper,
      createResumeEmptyDescriptionError: dataToParse?.create_resume_empty_description_error,
      createVacancyEmptyDescriptionError: dataToParse?.create_vacancy_empty_description_error,
      vacancyMinCharCountErrorText: dataToParse?.vacancy_error_message_description_min_count,
      specialtyMinCharCountErrorText: dataToParse?.resume_error_message_description_min_count,
      createSpecialtyMinCharCountErrorText: dataToParse?.create_resume_error_message_description_min_count,
      createVacancyMinCharCountErrorText: dataToParse?.create_vacancy_error_message_description_min_count,
      createSpecialtyJobTitleMinCharCountErrorText: dataToParse?.create_resume_error_message_job_title_min_count,
      createVacancyJobTitleMinCharCountErrorText: dataToParse?.create_vacancy_error_message_job_title_min_count
    },
    myProfile: {
      hiringTabEmptyState: dataToParse?.my_profile_hiring_tab_empty_state,
      openToTabEmptyState: dataToParse?.my_profile_open_to_tab_empty_state,
      tableSectionDreamJob: dataToParse?.my_profile_table_section_dream_job,
      dreamJobBottomSheet: dataToParse?.my_profile_dream_job_bottom_sheet,
      openToBottomSheet: dataToParse?.my_profile_open_to_bottom_sheet,
      trustedText: dataToParse?.my_profile_trusted_text,
      websitesPlaceholder: dataToParse?.my_profile_websites_placeholder,
      tagsPlaceholder: dataToParse?.my_profile_tags_placeholder,
      aboutPlaceholder: dataToParse?.my_profile_about_placeholder,
      segmentedControlHiring: dataToParse?.profile_offering_listings_section,
      segmentedControlOpenTo: dataToParse?.profile_open_to_listings_section,
      segmentedControlAbout: dataToParse?.my_profile_segmented_control_about,
      profileLinkCopied: dataToParse?.profile_link_copied,
      profileUrl: dataToParse?.profile_table_section_url,
      contactInfo: dataToParse?.profile_table_section_contact_info,
      resumeDeleteButton: dataToParse?.resume_delete_alert_button,
      vacancyDeleteButton: dataToParse?.vacancy_delete_alert_button,
      resumeDeleteCancelButton: dataToParse?.resume_delete_cancel_button,
      vacancyDeleteCancelButton: dataToParse?.vacancy_delete_cancel_button,
      profileEditingCancelButton: dataToParse?.profile_editing_cancel_button,
      profileEditingSaveButton: dataToParse?.profile_changes_save_button,
      segmentedControlGroup: dataToParse?.my_profile_segmented_control_group,
      groupSectionPlaceholder: dataToParse?.my_profile_group_placeholder,
      groupSectionShowLessTitle: dataToParse?.my_profile_group_section_show_less_title,
      groupSectionShowMoreTitle: dataToParse?.my_profile_group_section_show_more_title,
      swapModalEmptyStateTitle: dataToParse?.empty_search_state_title_swap,
      swapModalEmptyStateDescription: dataToParse?.empty_search_state_subtitle_swap,
      emptyProfileAddPostButton: dataToParse?.empty_state_button_create_post,
      emptyProfileAddPostTitle: dataToParse?.empty_state_profile_listings_title,
      emptyProfileAddPostDescription: dataToParse?.empty_state_profile_listings_description
    },
    otherProfile: {
      chatButton: dataToParse?.other_profile_chat_button,
      introduceButton: dataToParse?.other_profile_introduce_button,
      contactBottomSheetUntrust: dataToParse?.other_contact_bottom_sheet_untrust,
      contactBottomSheetTrust: dataToParse?.other_contact_bottom_sheet_trust,
      contactBottomSheetShare: dataToParse?.other_contact_bottom_sheet_share,
      contactBottomSheetAddContact: dataToParse?.other_contact_bottom_sheet_add_contact,
      tableSectionDreamJob: dataToParse?.other_profile_table_section_dream_job,
      hiringTabEmptyState: dataToParse?.other_profile_hiring_tab_empty_state,
      openToTabEmptyState: dataToParse?.other_profile_open_to_tab_empty_state,
      segmentedControlHiring: dataToParse?.other_profile_offering_listings_section,
      segmentedControlOpenTo: dataToParse?.other_profile_open_to_listings_section,
      segmentedControlAbout: dataToParse?.other_profile_segmented_control_about,
      profileLinkCopied: dataToParse?.profile_link_copied,
      profileUrl: dataToParse?.profile_table_section_url,
      trustingModalEmptyStateTitle: dataToParse?.trusting_modal_empty_state_title,
      trustingModalEmptyStateDescription: dataToParse?.trusting_modal_empty_state_description,
      trustingModalTitle: dataToParse?.trusting_modal_title,
      trustListSearchPlaceholder: dataToParse?.trust_list_search_placeholder,
      publicProfileSignupModalProfile: dataToParse?.public_profile_signup_modal_profile,
      publicProfileSignupModalListings: dataToParse?.public_profile_signup_modal_listings,
      shareOtherProfile: dataToParse?.other_profile_popup_actions_share,
      blockOtherProfile: dataToParse?.other_contact_bottom_sheet_block,
      errorLoadingPublicResume: dataToParse?.error_loading_public_resume,
      errorLoadingPublicVacancy: dataToParse?.error_loading_public_vacancy,
      errorLoadingPublicProfile: dataToParse?.error_loading_public_profile,
      segmentedControlGroup: dataToParse?.other_profile_segmented_control_group,
      groupSectionShowLessTitle: dataToParse?.other_profile_group_section_show_less_title,
      groupSectionShowMoreTitle: dataToParse?.other_profile_group_section_show_more_title,
      blockedByMyUserCardTitle: dataToParse?.blocked_by_my_user_card_title,
      blockedByMyUserCardDescription: dataToParse?.blocked_by_my_user_card_description,
      blockedByOtherUserCardTitle: dataToParse?.blocked_by_other_user_card_title,
      blockedByOtherUserCardDescription: dataToParse?.blocked_by_other_user_card_description,
      unblockProfileButton: dataToParse?.unblock_profile_button,
      blockedUsersTitle: dataToParse?.blocked_users_title,
      blockedUsersSearchPlaceholder: dataToParse?.blocked_users_search_placeholder,
      blockedUsersEmptySearchTitle: dataToParse?.blocked_users_empty_search_title,
      blockedUsersEmptySearchSubTitle: dataToParse?.blocked_users_empty_search_subtitle,
      blockedUsersUnblockButton: dataToParse?.blocked_users_unblock_button,
      blockedUsersUnblockAlertTitle: dataToParse?.blocked_users_unblock_alert_title,
      blockedUsersUnblockAlertMessage: dataToParse?.blocked_users_unblock_alert_message,
      blockedUsersUnblockAlertCancelButton: dataToParse?.blocked_users_unblock_alert_cancel_button,
      blockedUsersUnblockAlertUnblockButton: dataToParse?.blocked_users_unblock_alert_unblock_button,
      blockedUsersTrustedByText: dataToParse?.blocked_users_trusted_by_text,
      blockedUsersEmptyContainerTitle: dataToParse?.blocked_users_empty_state_title,
      blockedUsersEmptyContainerDescription: dataToParse?.blocked_users_empty_state_description
    },
    introduce: {
      seeChatButton: dataToParse?.introduce_alert_see_chat_button,
      okButton: dataToParse?.introduce_alert_ok,
      exploreCreatedOkButton: dataToParse?.explore_created_ok,
      titleSuccessModal: dataToParse?.introduce_alert_title,
      accountDeletedModalTitle: dataToParse?.introduce_account_deleted_modal_title,
      accountDeletedModalDescription: dataToParse?.introduce_account_deleted_modal_description,
      recommendedBy: dataToParse?.contacts_text_recommended_by,
      description: dataToParse?.introduce_message_description,
      emptyMessageError: dataToParse?.introduce_empty_message_error,
      messagePlaceholder: dataToParse?.introduce_message_placeholder,
      sendButton: dataToParse?.introduce_message_send_button,
      closeButton: dataToParse?.introduce_close_button,
      alreadyIntroduced: dataToParse?.introduce_alert_users_already_introduced,
      chooseSomeoneElse: dataToParse?.introduce_error_choose_someone_else,
      modalTitle: dataToParse?.introduce_modal_title,
      chooseSomeoneToIntroduce: dataToParse?.please_choose_someone_to_introduce,
      chooseButton: dataToParse?.introduce_choose_button,
      firstModalTitle: dataToParse?.introduce_title,
      introEmptyTitle: dataToParse?.intro_empty_title,
      introEmptyDescription: dataToParse?.intro_empty_description,
      searchIntroUserPlaceholder: dataToParse?.search_intro_user_placeholder,
      introductionBy: dataToParse?.introduction_by
    },
    errorMsgs: {
      emptySearchStateTitle: dataToParse?.empty_search_state_title,
      networkEmptySearchStateTitle: dataToParse?.empty_search_state_title_network,
      emptySearchStateSubTitle: dataToParse?.empty_search_state_sub_title,
      emptyNetworkSearchStateSubTitle: dataToParse?.empty_network_search_state_sub_title,
      locationTypeError: dataToParse?.profile_publish_location_typ_error_text,
      locationError: dataToParse?.profile_publish_locations_error_text,
      rateError: dataToParse?.profile_publish_rate_error_text,
      helperJobTitle: dataToParse?.empty_job_title_error,
      helperTextRepeatTag: dataToParse?.profile_edit_text_exist_tag_error,
      errorMsgCurrency: dataToParse?.vacancies_add_vacancy_error_message_currency,
      errorMsgLocationsLimit: dataToParse?.vacancies_error_message_locations_max_count,
      errorMsgDescriptionLimit: dataToParse?.vacancies_error_message_description_max_count,
      tagsLimitErrorMsg: dataToParse?.profile_edit_text_tags_limit_error,
      helperTextLimit: dataToParse?.profile_edit_text_limit_error,
      helperTextMinLength: dataToParse?.profile_edit_url_min_length_error,
      usernameMinLength: dataToParse?.profile_edit_text_username_min_length_error,
      helperTextLimitMin: dataToParse?.min_text_limit_error,
      locationExistError: dataToParse?.vacancies_error_message_exist_location_error,
      wrongLocation: dataToParse?.vacancies_error_message_wrong_location,
      vacanciesRequiredLocation: dataToParse?.vacancies_error_message_required_location
    },
    chatTexts: {
      title: dataToParse?.bottom_navigation_messages,
      contacts: dataToParse?.bottom_navigation_contacts,
      listings: dataToParse?.bottom_navigation_my_profile,
      messageSuccessModal: dataToParse?.introduce_alert_message,
      chatName: dataToParse?.messages_text_introduce_chat_name,
      messageSeenBy: dataToParse?.messages_seen_by,
      offline: dataToParse?.chat_text_user_is_offline,
      online: dataToParse?.chat_text_user_is_online,
      placeholder: dataToParse?.chat_text_placeholder,
      deletedAccount: dataToParse?.chat_text_deleted_account,
      chatTextMe: dataToParse?.chat_text_me,
      selectChat: dataToParse?.chat_text_select_contact,
      messagesEmptyTitle: dataToParse?.messages_empty_title,
      messagesEmptyDescription: dataToParse?.messages_empty_description,
      messagesFileUpload: dataToParse?.messages_file_upload,
      matchedMessages: dataToParse?.messages_search_matched_messages,
      startedVacancyChat: dataToParse?.conversation_started_vacancy,
      startedSpecialtyChat: dataToParse?.conversation_started_specialty,
      microphonePermissionDisabled: dataToParse?.chat_text_microphone_permission_disabled,
      audioRecordingSecondsLimit: dataToParse?.audio_recording_seconds_limit,
      voiceMessage: dataToParse?.chat_audio_cell_title,
      chatNoMessageSubtitle: dataToParse?.chat_text_no_message_subtitle_for_introduce,
      chatNoMessageTitle: dataToParse?.chat_text_no_message_title,
      chatTextAnd: dataToParse?.chat_text_and,
      chatMenuTextCopy: dataToParse?.chat_action_menu_copy,
      chatMenuTextDelete: dataToParse?.chat_action_menu_delete,
      chatMenuTextReply: dataToParse?.chat_action_menu_reply,
      chatMenuTextSave: dataToParse?.chat_action_menu_save,
      chatSearchPlaceholder: dataToParse?.chat_search_placeholder,
      chatSeenDateToday: dataToParse?.chat_seen_date_today,
      chatSeenDateYesterday: dataToParse?.chat_seen_date_yesterday
    },
    onboarding: {
      enterYourNumber: dataToParse?.phone_enter_text_enter_your_number,
      phoneInputPlaceholder: dataToParse?.phone_input_placeholder,
      resendCodeWaiting: dataToParse?.phone_verification_button_resend_code_waiting,
      yourName: dataToParse?.authentication_name_enter_text_first_name,
      yourLastName: dataToParse?.authentication_name_enter_text_last_name,
      yourUserName: dataToParse?.authentication_name_enter_text_user_name,
      helperFirstName: dataToParse?.authentication_name_enter_text_first_name_error,
      helperLastName: dataToParse?.authentication_name_enter_text_last_name_error,
      discardChangesSubTitle: dataToParse?.profile_edit_text_discard_changes_subtitle,
      discardChangesTitle: dataToParse?.profile_edit_text_discard_changes_title,
      discardButtonText: dataToParse?.voice_recording_warning_modal_discard,
      cancelButtonText: dataToParse?.button_cancel,
      landingTitle: dataToParse?.landing_title,
      landingPhoneNumber: dataToParse?.landing_your_phone_number,
      landingLogIn: dataToParse?.landing_log_in,
      landingSignUp: dataToParse?.landing_sign_up,
      authLogIn: dataToParse?.authentication_log_in,
      authSignUp: dataToParse?.authentication_sign_up,
      textLegalAgree: dataToParse?.phone_enter_text_legal_agree,
      textLegalTerms: dataToParse?.phone_enter_text_legal_terms,
      resendCode: dataToParse?.phone_verification_button_resend_code,
      authenticationUrlTerms: dataToParse?.authentication_phone_enter_url_terms,
      privacyPolicyTitle: dataToParse?.profile_settings_sheet_actions_privacy_policy,
      childSafetyPolicyTitle: dataToParse?.profile_settings_sheet_actions_child_safety_policy,
      termsAndPolicies: dataToParse?.profile_settings_sheet_actions_terms_and_policies,
      termsAndPoliciesTitle: dataToParse?.profile_settings_sheet_actions_terms_and_policies_title,
      policyPagePrivacyLinkText: dataToParse?.policy_page_privacy_link_text,
      policyPageTermsLinkText: dataToParse?.policy_page_terms_link_text,
      policyPageChildSafetyLinkText: dataToParse?.policy_page_child_safety_link_text,
      pageDoesNotExistTitle: dataToParse?.page_does_not_exist_title,
      pageDoesNotExistDesc: dataToParse?.page_does_not_exist_desc,
      pageDoesNotExistButton: dataToParse?.page_does_not_exist_button,
      authenticationUrlPrivacy: dataToParse?.authentication_phone_enter_url_privacy,
      textLegalPrivacy: dataToParse?.phone_enter_text_legal_privacy,
      textLegalAnd: dataToParse?.phone_enter_text_legal_and,
      buttonContinue: dataToParse?.phone_enter_button_continue,
      verificationEnterCodeFor: dataToParse?.phone_verification_text_enter_code,
      dreamJobTitle: dataToParse?.authentication_dream_jobs_text_title,
      titleFirstTime: dataToParse?.phone_enter_title_first_time,
      displayNameTextTitle: dataToParse?.authentication_display_name_text_title,
      backButton: dataToParse?.navigation_bar_button_back,
      popularChoice: dataToParse?.onboarding_popular_choice,
      dreamJobSubTitle: dataToParse?.authentication_dream_jobs_text_subtitle,
      photoTitle: dataToParse?.authentication_upload_photo_header_title,
      photoSubtitle: dataToParse?.authentication_upload_photo_header_subtitle,
      dreamJobDescription: dataToParse?.authentication_dream_jobs_text_description,
      displayNameSubtitle: dataToParse?.authentication_name_enter_text_subtitle,
      displayNameDescription: dataToParse?.authentication_name_enter_text_name,
      yourChoice: dataToParse?.onboarding_your_choice,
      invalidCode: dataToParse?.phone_verification_hud_incorrect_code,
      jobTextSubtitle: dataToParse?.choose_job_text_subtitle,
      employerSubtitleStages: dataToParse?.multichoice_stages_investor_subtitle,
      employeeSubtitleIndustries: dataToParse?.multichoice_industries_investor_subtitle,
      employerSubtitleIndustries: dataToParse?.multichoice_industries_founder_subtitle,
      jobTextTitle: dataToParse?.choose_job_text_title,
      employeeSelectSpeciality: dataToParse?.choose_job_text_speciality,
      selectLocation: dataToParse?.choose_job_text_location,
      switchButtonOnSite: dataToParse?.choose_job_switch_button_on_site,
      switchButtonRemote: dataToParse?.choose_job_switch_button_remote,
      switchButtonsTitle: dataToParse?.choose_job_switch_buttons_title,
      dreamJobKeywords: dataToParse?.profile_add_vacancies_job_titles_keywords,
      tagsTitle: dataToParse?.profile_table_section_name_tags,
      tagsDescription: dataToParse?.tags_editor_description,
      tagsSubtitle: dataToParse?.tags_text_field_title,
      vacancyTitle: dataToParse?.profile_table_section_vacancy,
      vacancyDescription: dataToParse?.profile_add_vacancies_description,
      salarySubtitle: dataToParse?.salary_subtitle,
      salaryTitle: dataToParse?.salary_title,
      currency: dataToParse?.profile_add_vacancies_currency,
      optional: dataToParse?.profile_add_vacancies_optional,
      salaryFrom: dataToParse?.profile_add_vacancies_from,
      salaryTo: dataToParse?.profile_add_vacancies_to,
      companyInfoWebsite: dataToParse?.company_info_website,
      vacancyPeyPeriodDay: dataToParse?.vacancies_add_vacancies_pay_period_day,
      vacancyPeyPeriodHour: dataToParse?.vacancies_add_vacancies_pay_period_hour,
      vacancyPeyPeriodMonth: dataToParse?.vacancies_add_vacancies_pay_period_month,
      vacancyPeyPeriodYear: dataToParse?.vacancies_add_vacancies_pay_period_year,
      vacancyPeyPeriodWeek: dataToParse?.vacancies_add_vacancies_pay_period_week,
      companyInfo: dataToParse?.company_info_company,
      alreadySwitchButton: dataToParse?.authentication_dream_job_switch_button_already,
      vacancyFixedPrice: dataToParse?.vacancies_add_vacancies_pay_period_piece,
      placeholderVerificationCode: dataToParse?.phone_verification_code_message,
      msgForLimitExceeded: dataToParse?.phone_invalid_attempts_limit,
      msgForInvalidNumber: dataToParse?.phone_invalid_short_number,
      footerCopyright: dataToParse?.footer_uplift_copyright,
      msgForInvalidPhoneNumber: dataToParse?.auth_invalid_phone_number,
      msgForNoInternetAccess: dataToParse?.auth_no_internet_access,
      generalErrorMsg: dataToParse?.auth_general_error_message,
      nameTextTitle: dataToParse?.authentication_name_enter_text_title,
      nameTextSubTitle: dataToParse?.authentication_name_enter_text_subtitle,
      jobTextDescription: dataToParse?.current_job_title,
      splashScreenTitle: dataToParse?.authentication_greetings_screen_welcome_first_time_title,
      nameStepButtonContinue: dataToParse?.authentication_name_enter_button_continue,
      nameStepButtonBack: dataToParse?.authentication_name_enter_button_back,
      jobButtonNext: dataToParse?.authentication_job_button_next,
      jobButtonBack: dataToParse?.authentication_job_button_back,
      dreamJobsButtonNext: dataToParse?.authentication_dream_jobs_button_next,
      dreamJobsButtonBack: dataToParse?.authentication_dream_jobs_button_back,
      photoButtonStart: dataToParse?.authentication_greetings_screen_button_start,
      photoButtonBack: dataToParse?.authentication_photo_button_back,
      lastUpdatedDateOfChildSafetyPolicy: dataToParse?.last_updated_date_of_child_safety_policy
    },
    vacancies: {
      edited: dataToParse?.vacancies_edited,
      fullTime: dataToParse?.vacancies_job_type_full_time,
      partTime: dataToParse?.vacancies_job_type_part_time,
      contractor: dataToParse?.vacancies_job_type_contractor,
      smallJobs: dataToParse?.vacancies_job_type_small_jobs,
      internship: dataToParse?.vacancies_job_type_internship,
      volunteer: dataToParse?.vacancies_job_type_volunteer,
      advisor: dataToParse?.vacancies_job_type_advisor,
      boardDirectors: dataToParse?.vacancies_job_type_board_of_directors,
      projectBased: dataToParse?.vacancies_job_type_project_based,
      startupBusinessPartner: dataToParse?.vacancies_job_type_startup_businness_partner,
      payPeriodPiece: dataToParse?.vacancies_add_vacancies_pay_period_piece,
      onlyTrusts: dataToParse?.vacancies_job_audience_only_trusts,
      myNetwork: dataToParse?.vacancies_job_audience_my_network,
      inPerson: dataToParse?.vacancies_location_type_in_person,
      remote: dataToParse?.choose_job_switch_button_remote,
      hybrid: dataToParse?.vacancies_location_type_hybrid,
      strangers: dataToParse?.vacancies_job_audience_strangers,
      onlyMe: dataToParse?.vacancies_job_audience_only_me,
      openToEdited: dataToParse?.profile_open_to_edited,
      openToPublished: dataToParse?.profile_open_to_published,
      vacancyDetailOpenToWork: dataToParse?.vacancy_detail_open_to_work,
      vacancyDetailHiringBy: dataToParse?.vacancy_detail_hiring_by,
      profileTagsPlaceholder: dataToParse?.profile_tags_placeholder_text
    },
    home: {
      cardNotFoundTitle: dataToParse?.home_card_not_found_title,
      homeCardNotFoundGoToHome: dataToParse?.home_card_not_found_go_to_home,
      title: dataToParse?.bottom_navigation_swiper,
      homeTitle: dataToParse?.home_recommendations_title,
      homeSearchPlaceholder: dataToParse?.home_search_placeholder,
      startChatButton: dataToParse?.contacts_profile_button_open_chat,
      skipButton: dataToParse?.contacts_profile_button_skip,
      filtersTitle: dataToParse?.home_filters_title,
      iosApplication: dataToParse?.ios_application,
      androidApplication: dataToParse?.android_application,
      homeDescription: dataToParse?.home_no_matches_description,
      exploreNoMatchesTitle: dataToParse?.explore_no_matches_title,
      exploreNoMatchesDescription: dataToParse?.explore_no_matches_description,
      trustedBy: dataToParse?.profile_table_section_trusted_by,
      others: dataToParse?.swiper_text_others,
      other: dataToParse?.swiper_text_other,
      trustedPath: dataToParse?.profile_table_section_trust_path,
      explorePageTitle: dataToParse?.explore_page_title,
      explorePageFrom: dataToParse?.explore_page_from,
      explorePageStartChat: dataToParse?.explore_page_start_a_chat,
      explorePageArchiveJob: dataToParse?.explore_page_archive_job,
      explorePageEditJob: dataToParse?.explore_page_edit_job,
      buttonGoToGroupChat: dataToParse?.button_go_to_group_chat,
      explorePageChat: dataToParse?.explore_page_chat,
      explorePageIntroduce: dataToParse?.explore_page_introduce,
      exploreLinkTitle: dataToParse?.explore_link_title,
      exploreLinkCopyMessage: dataToParse?.explore_link_copy_message,
      exploreInviteViaLink: dataToParse?.explore_invite_via_link,
      exploreCreateOpenTo: dataToParse?.explore_create_open_to,
      cardPopupActionsShare: dataToParse?.card_popup_actions_share,
      cardPopupActionsHide: dataToParse?.card_popup_actions_hide,
      cardPopupActionsEdit: dataToParse?.job_card_bottom_sheet_edit,
      cardPopupActionsArchive: dataToParse?.job_card_bottom_sheet_archive,
      cardPopupActionsDelete: dataToParse?.job_card_bottom_sheet_delete,
      cardPopupActionsShareTitle: dataToParse?.card_popup_actions_share_title,
      cardPopupActionsShareCopyText: dataToParse?.card_popup_actions_share_copy_text,
      cardPopupActionsShareCopied: dataToParse?.card_popup_actions_share_copied,
      cardPopupActionsShareFacebookTitle: dataToParse?.card_popup_actions_share_facebook_title,
      cardPopupActionsShareLinkedInTitle: dataToParse?.card_popup_actions_share_linked_in_title,
      cardPopupActionsShareWhatsAppTitle: dataToParse?.card_popup_actions_share_whats_app_title,
      cardPopupActionsShareGmailTitle: dataToParse?.card_popup_actions_share_gmail_title,
      cardPopupActionsShareGmailBody: dataToParse?.card_popup_actions_share_gmail_body,
      cardPopupActionsShareWhatsAppBody: dataToParse?.card_popup_actions_share_whats_app_body,
      cardPopupActionsShareTelegramTitle: dataToParse?.share_telegram_title,
      cardPopupActionsShareTwitterTitle: dataToParse?.share_twitter_title,
      cardPopupActionsShareRedditTitle: dataToParse?.share_reddit_title,
      cardPopupActionsSharePinterestTitle: dataToParse?.share_pinterest_title,
      cardPopupActionsShareXingTitle: dataToParse?.share_xing_title,
      cardPopupActionsShareSnapchatTitle: dataToParse?.share_snapchat_title,
      cardPopupActionsShareTumblrTitle: dataToParse?.share_tumblr_title,
      exploreCreateHiring: dataToParse?.explore_create_hiring,
      exploreShowMore: dataToParse?.explore_page_show_more,
      exploreShowFewer: dataToParse?.explore_page_show_fewer,
      exploreCreatedTitle: dataToParse?.explore_created_title,
      homeMatchesHiring: dataToParse?.job_details_vacancy,
      homeMatchesOpenTo: dataToParse?.job_details_resume,
      homeOpenChatModalOk: dataToParse?.home_open_chat_modal_ok,
      homeOpenChatModalCancel: dataToParse?.home_open_chat_modal_cancel,
      homeOpenChatModalTitle: dataToParse?.home_open_chat_modal_title,
      homeOpenChatModalDescription: dataToParse?.home_open_chat_modal_description,
      homeButtonCreateJob: dataToParse?.home_button_create_job,
      homeFiltersOffering: dataToParse?.home_filters_offering,
      homeFiltersOpenTo: dataToParse?.home_filters_open_to,
      homeSkeletonTitle: dataToParse?.home_skeleton_title,
      vacancyCardInviteSubject: dataToParse?.vacancy_card_invite_subject,
      vacancyCardInviteBody: dataToParse?.vacancy_card_invite_body,
      specialityCardInviteSubject: dataToParse?.speciality_card_invite_subject,
      specialityCardInviteBody: dataToParse?.speciality_card_invite_body
    },
    support: {
      title: dataToParse?.support_page_title,
      description: dataToParse?.support_page_description,
      inputName: dataToParse?.support_page_input_name,
      inputEmail: dataToParse?.support_page_input_email,
      inputSubject: dataToParse?.support_page_input_subject,
      inputMessage: dataToParse?.support_page_input_message,
      inputSubjectTechnicalSupport: dataToParse?.support_page_input_subject_option_techincal_support,
      inputSubjectEnterpriseSalse: dataToParse?.support_page_input_subject_option_enterprise_sales,
      inputSubjectReportUser: dataToParse?.support_page_input_subject_option_report_user,
      inputSubjectReportContent: dataToParse?.support_page_input_subject_option_report_content,
      inputSubjectOther: dataToParse?.support_page_input_subject_option_other,
      addAttachment: dataToParse?.support_page_add_attachment,
      attachmentSizeLimit: dataToParse?.support_page_attachment_size_limit,
      maxFileCountLimit: dataToParse?.support_page_max_file_count_limit,
      maxFilesSizeLimit: dataToParse?.support_page_max_files_size_limit,
      sendMessage: dataToParse?.support_page_send_message,
      yourRequestSendTitle: dataToParse?.support_page_your_request_send_title,
      yourRequestSendDescription: dataToParse?.support_page_your_request_send_description,
      sendAnotherMessage: dataToParse?.support_page_send_another_message,
      pleaseEnterName: dataToParse?.support_page_please_enter_name,
      pleaseEnterEmail: dataToParse?.support_page_please_enter_email,
      pleaseEnterValidEmail: dataToParse?.support_page_please_enter_valid_email,
      pleaseSelectSubject: dataToParse?.support_page_please_select_subject,
      pleaseEnterMessage: dataToParse?.support_page_please_enter_message,
      supportPageUploadFailed: dataToParse?.support_page_upload_failed
    },
    listing: {
      listingTitle: dataToParse?.listings_title,
      listingTitleOtherProfile: dataToParse?.other_profile_listings_title,
      listingEmptyStateTitle: dataToParse?.empty_state_all_listings_title,
      listingFiltersAll: dataToParse?.listings_filter_all,
      listingFiltersOffering: dataToParse?.listings_filter_vacancy,
      listingFiltersOpenTo: dataToParse?.listings_filter_resume,
      listingFiltersAllOther: dataToParse?.listings_filter_all_other,
      listingFiltersOfferingOther: dataToParse?.listings_filter_vacancy_other,
      listingFiltersOpenToOther: dataToParse?.listings_filter_resume_other,
      listingEmptyAll: dataToParse?.empty_state_all_listings_description,
      listingEmptyOpenTo: dataToParse?.empty_state_open_to_listings_description,
      listingEmptyOffering: dataToParse?.empty_state_offering_listings_description,
      listingEmptyOpenToOther: dataToParse?.other_profile_empty_open_to_listings_description,
      listingEmptyOfferingOther: dataToParse?.other_profile_empty_offering_listings_description,
      listingEmptyAllOther: dataToParse?.other_profile_empty_all_listings_description
    },
    archive: {
      archiveEmptyStateTitle: dataToParse?.empty_state_archive_title
    },
    settings: {
      viewProfile: dataToParse?.profile_settings_actions_view_profile,
      contactSupport: dataToParse?.profile_settings_actions_contact_support,
      deleteProfile: dataToParse?.profile_settings_actions_delete_profile,
      signOut: dataToParse?.profile_settings_sheet_actions_sign_out,
      signOutAlertTitle: dataToParse?.profile_sign_out_alert_title,
      profileDeleteMessage: dataToParse?.profile_delete_message,
      profileDeleteAreYouSureMessage: dataToParse?.profile_delete_are_you_sure_message,
      shareProfile: dataToParse?.profile_settings_actions_share,
      settingsSidebarPoliciesTitle: dataToParse?.profile_settings_actions_policies_title,
      shareMyProfileModalTitle: dataToParse.share_my_profile_modal_title,
      cancelButtonText: dataToParse?.profile_settings_modal_actions_sign_out_cancel,
      settingsButtonText: dataToParse?.profile_settings_sheet_settings_title,
      settingsSidebarTitle: dataToParse?.profile_settings_sheet_settings_title,
      settingsSidebarContactSupport: dataToParse?.profile_settings_actions_contact_support,
      settingsSidebarPrivacyPolicy: dataToParse?.profile_settings_sheet_actions_privacy_policy,
      settingsSidebarBlockedUsers: dataToParse?.profile_settings_actions_blocked_users,
      settingsSidebarTerms: dataToParse?.phone_enter_text_legal_terms,
      settingsSidebarChildSafetyPolicy: dataToParse?.profile_settings_sheet_actions_child_safety_policy,
      settingsSidebarDeleteProfile: dataToParse?.profile_settings_actions_delete_profile_alert_delete,
      settingsSidebarLanguage: dataToParse?.profile_change_language_title,
      settingsSidebarLanguageEnglish: dataToParse?.profile_change_language_english,
      settingsSidebarLanguageRussian: dataToParse?.profile_change_language_russian,
      settingsSidebarLanguageArmenian: dataToParse?.profile_change_language_armenian,
      settingsSidebarCurrentLanguageCode: dataToParse?.profile_change_current_language_code
    },
    errorModal: {
      jobDetailOutdatedInfo: dataToParse?.job_detail_error_outdated_info_message,
      errorModalContent: dataToParse?.profile_text_warning_message,
      errorMessageText: dataToParse?.error_alert_message_text,
      errorButton: dataToParse?.error_alert_button_reload,
      errorMessage: dataToParse?.error_alert_message_1,
      errorProfileDeletedTitle: dataToParse?.profile_text_not_found_title,
      errorProfileDeletedDesc: dataToParse?.profile_text_not_found_body,
      errorShareTokenExpiredTitle: dataToParse?.shared_link_token_expired,
      errorShareTokenExpiredDesc: dataToParse?.shared_link_cant_open_profile,
      errorModalButtonBack: dataToParse?.error_modal_button_back,
      errorModalButtonSignUp: dataToParse?.error_modal_button_sign_up,
      errorModalAddContactDesc: dataToParse?.error_modal_add_contact_desc,
      errorModalVacancyNotAvailableTitle: dataToParse?.error_modal_vacancy_not_available_title,
      errorModalSpecialtyNotAvailableTitle: dataToParse?.error_modal_specialty_not_available_title,
      errorModalVacancyNotAvailableDesc: dataToParse?.error_modal_vacancy_not_available_desc,
      errorModalSpecialtyNotAvailableDesc: dataToParse?.error_modal_specialty_not_available_desc,
      errorModalVacancyNotAvailableButton: dataToParse?.error_modal_vacancy_not_available_button,
      errorModalSpecialtyNotAvailableButton: dataToParse?.error_modal_specialty_not_available_button
    },
    toastMessages: {
      errorNewVacancy: dataToParse?.toast_error_vacancy_not_created,
      errorNewSpecialty: dataToParse?.toast_error_specialty_not_created,
      errorDeleteVacancy: dataToParse?.toast_error_delete_vacancy,
      errorDeleteSpecialty: dataToParse?.toast_error_delete_specialty,
      errorHideVacancy: dataToParse?.toast_error_hide_vacancy,
      errorHideSpecialty: dataToParse?.toast_error_hide_specialty,
      errorCloseVacancy: dataToParse?.toast_error_close_vacancy,
      errorCloseSpecialty: dataToParse?.toast_error_close_specality,
      errorEditVacancy: dataToParse?.toast_error_edit_vacancy,
      errorEditSpecialty: dataToParse?.toast_error_edit_specality,
      vacancyLimitMessage: dataToParse?.vacancy_limit_message,
      specialtyLimitMessage: dataToParse?.open_to_limit_message,
      specialtyEditedSuccessMessage: dataToParse?.specialty_edited_success_message,
      vacancyEditedSuccessMessage: dataToParse?.vacancy_edited_success_message,
      exploreHiringCreatedAlertMessage: dataToParse?.explore_hiring_created_message,
      exploreOpenToCreatedAlertMessage: dataToParse?.explore_open_to_created_message,
      listingsOpenToCreatedAlertMessage: dataToParse?.listings_open_to_created_message,
      listingsHiringCreatedAlertMessage: dataToParse?.listings_hiring_created_message,
      messageUserBlocked: dataToParse?.message_user_blocked,
      messageUserUnblocked: dataToParse?.blocked_users_toast_message,
      errorGlobalSearchMessage: dataToParse?.toast_error_global_search,
      errorGetMyGroups: dataToParse?.toast_error_get_my_groups,
      errorGetAllGroups: dataToParse?.toast_error_get_all_groups,
      errorGetGroup: dataToParse?.toast_error_get_group,
      errorAddNewGroup: dataToParse?.toast_error_create_group,
      errorUpdateGroup: dataToParse?.toast_error_update_group,
      errorUpdateGroupPrivacy: dataToParse?.toast_error_update_group_privacy,
      errorRemoveContact: dataToParse.error_remove_contact,
      errorBlockUser: dataToParse.error_block_contact,
      errorUnblockUser: dataToParse.error_unblock_user,
      errorLeaveGroup: dataToParse.error_leave_group,
      errorDeleteGroup: dataToParse.error_delete_group,
      errorRemoveUserFromGroup: dataToParse.error_remove_user_from_group,
      errorAddUserToGroup: dataToParse.error_add_user_to_group,
      errorJoinGroup: dataToParse.error_join_group,
      errorApproveJoinRequest: dataToParse.error_approve_join_request,
      errorDenyJoinRequest: dataToParse.error_deny_join_request,
      errorResetGroupLink: dataToParse.error_reset_group_link,
      errorTrustUser: dataToParse?.toast_error_trust_user,
      errorUntrustUser: dataToParse?.toast_error_untrust_user
    },
    snackbar: {
      dismissSnackbarMessage: dataToParse?.dismiss_toast_message,
      dismissSnackbarButton: dataToParse?.dismiss_toast_undo
    },
    publicData: {
      joinUs: dataToParse?.contacts_profile_text_join_us,
      joinUsModal: dataToParse?.contacts_profile_modal_text_join_us,
      signIn: dataToParse?.contacts_profile_text_sign_in,
      useAppSuggestion: dataToParse?.use_app_suggestion
    },
    appLinks: {
      googlePlay: dataToParse?.app_links_google_play,
      appStore: dataToParse?.app_links_app_store
    },
    editProfile: {
      setNewPhoto: dataToParse?.profile_edit_avatar,
      firstNameTitle: dataToParse?.profile_edit_first_name_title,
      lastNameTitle: dataToParse?.profile_edit_last_name_title,
      userNameTitle: dataToParse?.profile_edit_user_name_title,
      locationTitle: dataToParse?.profile_edit_location_title,
      companyTitle: dataToParse?.profile_edit_company_title,
      currentJobTitle: dataToParse?.profile_edit_current_job_title,
      currentJobMinCharCountErrorText: dataToParse?.profile_edit_current_job_min_char_count_error,
      saveButton: dataToParse?.profile_edit_save_button,
      cancelButton: dataToParse?.profile_edit_cancel_button,
      emptyUserNameError: dataToParse?.profile_edit_empty_user_name_error,
      userNameRegexError: dataToParse?.profile_edit_user_name_regex_error,
      usernameAlreadyExistsError: dataToParse?.profile_edit_username_already_exist_error,
      editGeneralInfo: dataToParse?.profile_edit_general_title,
      addWebsite: dataToParse?.my_profile_websites_placeholder,
      linkMinCharCountErrorText: dataToParse?.profile_edit_url_min_length_error,
      emailFieldError: dataToParse?.profile_edit_valid_email_error,
      emailLabel: dataToParse?.profile_edit_email,
      addEmailAddress: dataToParse?.profile_edit_empty_email_error,
      editBtn: dataToParse?.profile_edit_button,
      discardChangesPrimaryButtonText: dataToParse?.profile_header_edit_discard_changes_modal_primary_button_text,
      discardChangesSecondaryButtonText: dataToParse?.profile_header_edit_discard_changes_modal_secondary_button_text,
      discardChangesModalSubtitle: dataToParse?.profile_header_edit_tags_discard_changes_modal_subtitle,
      discardChangesModalTitle: dataToParse?.profile_header_edit_tags_discard_changes_modal_title
    }
  })
}

const getFallbackTranslations = () => {
  const currentLanguage = fetchCurrentLanguage()
  switch (currentLanguage) {
    case LANGUAGE_TYPE.HY:
      return translationsFallbackHY
    case LANGUAGE_TYPE.EN:
    default:
      return translationsFallbackEN
  }
}

const initialState = {
  isLoading: true,
  data: parser(getFallbackTranslations())
}

export const TranslationsReducer = (state = initialState, action: ActionTypes): typeof initialState => {
  switch (action.type) {
    case ACTION_TYPES.SET_DATA: return { ...state, data: parser(action.data), isLoading: false }
    case ACTION_TYPES.SET_IS_LOADING: return { ...state, isLoading: action.isLoading }
    default: return state
  }
}
